import { Navigate, useLocation } from "react-router-dom";
import { NumberParam, useQueryParam } from "use-query-params";

import SuperviseeProfileProvider from "../../context/SuperviseeProfileProvider";

const SupervisionModeRoute = ({ children }) => {
  const location = useLocation();
  const [superviseeId] = useQueryParam("supervisee_id", NumberParam);
  const isSupervisionMode = location?.pathname?.includes("supervision-mode");

  if (isSupervisionMode) {
    if (!superviseeId) return <Navigate to="/supervision" replace />;
    return (
      <SuperviseeProfileProvider
        superviseeId={superviseeId}
        isSupervisionMode={isSupervisionMode}
      >
        {children}
      </SuperviseeProfileProvider>
    );
  }
  return children;
};

export default SupervisionModeRoute;
